
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.488 11.752a.736.736 0 00-.173-.787L7.748 9.42l.022-.022A13.14 13.14 0 0010.553 4.5h1.454a.75.75 0 00.743-.743v-.014A.75.75 0 0012.008 3H7.5v-.75a.752.752 0 00-.75-.75.752.752 0 00-.75.75V3H1.492a.75.75 0 00-.742.743c0 .412.337.742.742.742h7.635A11.746 11.746 0 016.75 8.512a11.611 11.611 0 01-1.545-2.16A.664.664 0 004.62 6a.68.68 0 00-.593 1.013C4.5 7.86 5.077 8.67 5.753 9.42l-3.278 3.232c-.3.293-.3.773 0 1.066a.756.756 0 001.065 0L6.75 10.5l1.515 1.515a.745.745 0 001.223-.263zM13.125 7.5c-.45 0-.855.277-1.012.705l-2.753 7.35a.695.695 0 00.652.945c.293 0 .556-.18.66-.457l.668-1.793h3.563l.675 1.793c.104.27.367.457.66.457a.702.702 0 00.66-.945l-2.753-7.35a1.094 1.094 0 00-1.02-.705zm-1.215 5.25l1.215-3.248 1.215 3.248h-2.43z","fill":"#284A33"}})])
          )
        }
      }
    